export const NotificationEvents = {
  OPEN_NOTIFICATIONS: 'OPEN_NOTIFICATIONS',
};
